import DOMPurify from 'dompurify';

export const sanitizeHtml = (html, options = {}) => {
    const defaultConfig = {
        ALLOWED_TAGS: [
            // Basic HTML elements
            'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'blockquote', 'p', 'a', 'ul', 'ol',
            'nl', 'li', 'b', 'i', 'strong', 'em', 'strike', 'code', 'hr', 'br', 'div',
            'table', 'thead', 'caption', 'tbody', 'tr', 'th', 'td', 'pre', 'img', 'span',
            // Additional email-specific elements
            'font', 'center', 'u', 's', 'small', 'big', 'sup', 'sub'
        ],
        ALLOWED_ATTR: [
            // Basic attributes
            'class', 'style', 'align', 'href', 'target', 'src', 'alt', 'width', 'height',
            // Additional email-specific attributes
            'face', 'color', 'bgcolor', 'cellpadding', 'cellspacing', 'valign', 'border',
            'size', 'colspan', 'rowspan', 'lang', 'dir'
        ],
        ALLOWED_STYLES: {
            // Text styling
            'color': true,
            'background-color': true,
            'background': true,
            'text-align': true,
            'font-size': true,
            'font-family': true,
            'font-weight': true,
            'font-style': true,
            'text-decoration': true,
            'line-height': true,
            'letter-spacing': true,
            // Spacing and layout
            'padding': true,
            'padding-top': true,
            'padding-bottom': true,
            'padding-left': true,
            'padding-right': true,
            'margin': true,
            'margin-top': true,
            'margin-bottom': true,
            'margin-left': true,
            'margin-right': true,
            // Dimensions and positioning
            'width': true,
            'height': true,
            'max-width': true,
            'min-width': true,
            'border': true,
            'border-width': true,
            'border-style': true,
            'border-color': true,
            'border-radius': true,
            'display': true,
            'vertical-align': true,
            'position': true,
            'white-space': true,
            'word-break': true,
            'word-wrap': true,
            'overflow-wrap': true
        },
        FORBID_TAGS: ['script', 'style', 'iframe', 'frame', 'object', 'embed', 'form', 'link', 'meta'],
        FORBID_ATTR: ['onerror', 'onload', 'onclick', 'onmouseover', 'onmouseout', 'onmouseenter', 'onmouseleave'],
        RETURN_DOM: false,
        RETURN_DOM_FRAGMENT: false,
        RETURN_DOM_IMPORT: false,
        WHOLE_DOCUMENT: false,
        SANITIZE_DOM: true,
        ADD_TAGS: ['style'], // Allow style tags for email-specific CSS
        ADD_ATTR: ['type'] // Allow type attribute for style tags
    };

    // Clean and normalize the HTML before sanitizing
    let cleanHtml = html
        .replace(/<\!--.*?-->/g, '') // Remove comments
        .replace(/<style\b[^>]*>([\s\S]*?)<\/style>/gi, (match, styles) => {
            // Keep only valid CSS rules
            const cleanStyles = styles.replace(/[<>]/g, '');
            return `<style type="text/css">${cleanStyles}</style>`;
        });

    const mergedConfig = {
        ...defaultConfig,
        ...options,
        ALLOWED_STYLES: {
            ...defaultConfig.ALLOWED_STYLES,
            ...(options.ALLOWED_STYLES || {})
        },
        ALLOWED_ATTR: [
            ...defaultConfig.ALLOWED_ATTR,
            ...(options.ALLOWED_ATTR || [])
        ]
    };

    return DOMPurify.sanitize(cleanHtml, mergedConfig);
};